import { useEffect, useMemo } from "react";

import { useProjectActions, useProjectContext } from "@contexts/projects";

import ProjectionLoadState from "../../financialProjection/ProjectionLoadState";
import EapRuleRow from "./EapRuleRow";

const ServiceAccordion = ({ parent, months }) => {
  const {
    activeProject: { _id, services = {} },
    filterDates,
  } = useProjectContext();
  const { loadServices } = useProjectActions();

  useEffect(() => {
    if (_id) loadServices(parent);
  }, [_id, parent, filterDates]);

  const substepServices = useMemo(() => services[parent], [services, parent]);

  return (
    <>
      <ProjectionLoadState
        level="services"
        parent={parent}
        isMissing={!substepServices}
        onRetry={() => loadServices(parent)}
      />
      {substepServices?.map((item) => (
        <EapRuleRow
          key={item.wbs_code_id}
          item={item}
          type="service"
          typeTitle="Serviço"
          months={months}
        />
      ))}
    </>
  );
};

export default ServiceAccordion;
